import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ComponentsModule } from '../../../core/components/components.module';

import { AuthenticationRoutes } from './authentication.routes';
import { LoginPage } from './pages/login-page/login.page';
import { CreateAccountPage } from './pages/create-account/create-account.page';
import { ForgotPasswordPage } from './pages/forgot-password/forgot-password.page';
import { ResetPasswordPage } from './pages/reset-password/reset-password.page';

import { WhyRegisterComponent } from './pages/create-account/why-register-popup/why-register-popup.component';

import { HeaderModule } from '../../common/components/header/header.component.module';
import { MenuPopoverModule } from '../../common/components/menu-popover/menu-popover.component.module';

const routes: Routes = [
  AuthenticationRoutes.Login,
  AuthenticationRoutes.CreateAccount,
  AuthenticationRoutes.ForgotPassword,
  AuthenticationRoutes.ResetPassword
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    ComponentsModule,
    HeaderModule,
    MenuPopoverModule
  ],
  declarations: [
    LoginPage,
    CreateAccountPage,
    WhyRegisterComponent,
    ForgotPasswordPage,
    ResetPasswordPage
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AuthenticationModule {}